import { atom } from 'jotai';
import { atomWithStorage, createJSONStorage } from 'jotai/utils';

const storage = createJSONStorage<string[]>(() => localStorage);

export const cprGreenVerificationAtom = atom(false);
export const cprCloseVerificationBannerAtom = atomWithStorage<string[]>(
  'cprCloseVerificationBanner',
  [],
  storage,
);
